import nlNL from './nl-nl.json';
import nlBE from './nl-be.json';
import frBE from './fr-be.json';

export const defaultLocale = 'nlNL'

export const languages = {
  "nl-NL": nlNL,
  "nl-BE": nlBE,
  "fr-BE": frBE
}
